import "./styles/base.css";
import "./styles/auth.css";
import "./styles/hud.css";
import "./styles/city-view.css";
import "./styles/quest-board.css";
import "./styles/toast.css";
import "./styles/drawer.css";
import "./styles/footer.css";
import "./styles/responsive.css";

import { store } from "./lib/store.js";
import { initAuth } from "./lib/auth.js";
import { startRealtime } from "./lib/realtime.js";
import { mountLogin } from "./components/login.js";
import { mountHud } from "./components/hud.js";
import { mountCityView } from "./components/city-view.js";
import { mountQuestBoard } from "./components/quest-board.js";
import { mountToastTray } from "./components/toast.js";
import { mountDrawer } from "./components/drawer.js";
import { mountFooter } from "./components/footer.js";
import { registerKeyboardShortcuts } from "./utils/keyboard.js";
import { pushToast } from "./lib/toasts.js";

const app = document.getElementById("app");

let dashboardCleanup = null;
let loginCleanup = null;
let unregisterKeyboard = null;

function renderDashboard() {
  app.innerHTML = `
    <div id="hud-root"></div>
    <main id="city-view-root" class="main-view"></main>
    <div id="quest-board-root"></div>
    <div id="footer-root"></div>
    <div id="toast-root"></div>
    <div id="drawer-root"></div>
  `;

  const hudCleanup = mountHud(document.getElementById("hud-root"));
  const cityCleanup = mountCityView(document.getElementById("city-view-root"));
  const questBoard = mountQuestBoard(document.getElementById("quest-board-root"));
  const footerCleanup = mountFooter(document.getElementById("footer-root"));
  const toastCleanup = mountToastTray(document.getElementById("toast-root"));
  const drawer = mountDrawer(document.getElementById("drawer-root"));

  let stopRealtimePromise = startRealtime();

  unregisterKeyboard = registerKeyboardShortcuts({
    a: () => questBoard.focusFirstQuest(),
    enter: () => questBoard.approveFocusedQuest(),
    r: () => questBoard.rejectFocusedQuest(),
    escape: () => {
      drawer.close();
      questBoard.closeModals();
    },
    question: () => pushToast("info", "Atalhos: A abre o Quest Board, Enter aprova, R rejeita, Esc fecha, ? mostra esta ajuda."),
  });

  // system_alerts alimentam tanto o footer quanto toasts de erro de agente/
  // sentimento negativo/alerta financeiro (ver spec "Notificações toast").
  let previousAlertIds = new Set();
  const unsubscribeAlertToasts = store.systemAlerts.subscribe((alerts) => {
    const currentIds = new Set(alerts.map((a) => a.id));
    if (previousAlertIds.size > 0) {
      for (const alert of alerts) {
        if (!previousAlertIds.has(alert.id)) {
          pushToast(alert.severity === "P0" ? "error" : "warning", alert.message);
        }
      }
    }
    previousAlertIds = currentIds;
  });

  dashboardCleanup = async () => {
    const stopRealtime = await stopRealtimePromise;
    stopRealtime?.();
    hudCleanup();
    cityCleanup();
    questBoard.destroy();
    footerCleanup();
    toastCleanup();
    drawer.destroy();
    unregisterKeyboard?.();
    unsubscribeAlertToasts();
  };
}

async function renderLogin() {
  app.innerHTML = `<div id="login-root"></div>`;
  loginCleanup = mountLogin(document.getElementById("login-root"));
}

async function boot() {
  await initAuth();

  store.session.subscribe(async (session) => {
    if (session) {
      if (loginCleanup) {
        loginCleanup();
        loginCleanup = null;
      }
      if (!dashboardCleanup) renderDashboard();
    } else {
      if (dashboardCleanup) {
        await dashboardCleanup();
        dashboardCleanup = null;
      }
      if (!loginCleanup) renderLogin();
    }
  });
}

boot();
